export const INSTAGRAM = {
  handle: 'evar.stores',
  url: 'https://www.instagram.com/evar.stores',
};

export const REELS = [
  'https://www.instagram.com/reel/DbWB1HYKCMI/',
  'https://www.instagram.com/reel/DbgbJkFK4ov/',
  'https://www.instagram.com/reel/Db0oZgDK4a2/',
  'https://www.instagram.com/reel/DbtU4rUqDSD/',
  'https://www.instagram.com/reel/Db_BuLcKbiY/',
  'https://www.instagram.com/reel/DbljMObqqhg/',
  'https://www.instagram.com/reel/DbbPrx5qJv8/'
];
